import { useEffect } from 'react';
import { Box, Button, TextField, useTheme } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik, useFormik } from 'formik';
import * as yup from 'yup';
import useMediaQuery from '@mui/material/useMediaQuery';
import Header from '../../components/Header';
import { useStore, getCampusById } from '../../store';
// import {
//   useGetCategoryQuery,
//   useUpdateCategoryMutation,
// } from '../../features/categories/categoryApi';
import Spinner from '../../components/Spinner';
import { tokens } from '../../theme';

const CampusEditTable = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNonMobile = useMediaQuery('(min-width:600px)');
  const { id } = useParams();
  const navigate = useNavigate();

  const campusToEdit = useStore(getCampusById(id));
  // const {
  //   data: campusToEdit,
  //   isLoading: isCategoryLoading,
  //   isError: isCategoryError,
  //   error: categoryError,
  // } = useGetCategoryQuery(id); // Replace '1' with the desired post ID

  // const [updateCategory] = useUpdateCategoryMutation();

  const updateCampusApiCall = useStore((state) => state.updateCampusAPI);

  const onSubmit = async (values, actions) => {
    if (!campusToEdit) return;

    // try {
    //   const updatedCategory = await updateCategory({
    //     ...campusToEdit,
    //     ...values,
    //   }).unwrap();

    //   // Clear the form
    //   // Deselect the post
    // } catch (err) {

    // }
    try {
      await updateCampusApiCall({
        _id: values._id,
        name: values.name,
        description: values.description,
      });
      actions.resetForm();
      navigate('/campuses');
    } catch (err) {}
    // await updateCampusApiCall(values);
    // actions.resetForm();
    // navigate('/categories');
  };

  useEffect(() => {}, []);

  const {
    values,
    errors,
    touched,
    handleBlur,
    isSubmitting,
    setFieldValue,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: campusToEdit,
    validationSchema: checkoutSchema,
    onSubmit,
  });
  return (
    <Box m="20px">
      <Header title="EDIT CATEGORY" subtitle="Edit a Meal Category" />
      <form autoComplete="off" onSubmit={handleSubmit}>
        <Box
          display="grid"
          gap="30px"
          gridTemplateColumns="repeat(4, minmax(0, 1fr))"
          sx={{
            '& > div': { gridColumn: isNonMobile ? undefined : 'span 4' },
          }}
        >
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Name"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.name}
            name="name"
            error={!!touched.name && !!errors.name}
            helperText={touched.name && errors.name}
            sx={{ gridColumn: 'span 4' }}
          />
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Description"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.description}
            name="description"
            error={!!touched.description && !!errors.description}
            helperText={touched.description && errors.description}
            sx={{ gridColumn: 'span 4' }}
          />
        </Box>
        <Box display="flex" justifyContent="end" mt="20px">
          <Button
            sx={{
              backgroundColor: colors.redAccent[500],
              color: '#fff',
            }}
            disabled={isSubmitting}
            type="submit"
            color="secondary"
            variant="contained"
          >
            {isSubmitting ? <Spinner color="#888" /> : `Update Campus`}
          </Button>
        </Box>
      </form>
      {/* )}
        </Formik> */}
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
});
const initialValues = {
  name: '',
};

export default CampusEditTable;
